import axiosPrivateMl from "@services/axiosPrivateMl"
import { GET_DUPLICATE_CREATIVE_URL } from "../../constants"

export const getDuplicateCreativeUrlFromCDN = (data) => {
  return axiosPrivateMl.post(GET_DUPLICATE_CREATIVE_URL, data)
}
